import { useEffect } from 'react';

import { useResponsive } from '@depop/web-ui-kit/useResponsive';

import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useIsHomepage } from '@/modules/home/hooks/useIsHomepage';

export function useShowHomepageSearchBar() {
  const isHomepage = useIsHomepage();
  const { isMaxMedium: isMobile } = useResponsive();

  const [{ web_7019_visible_search_bar_mweb }, bucketStickySearchbar] =
    useExperiments(['web_7019_visible_search_bar_mweb'], {
      deferred: true,
    });

  useEffect(() => {
    if (isHomepage && isMobile) {
      bucketStickySearchbar();
    }
  }, [isHomepage, isMobile]);

  return {
    /* Always render on homepage - CSS handles mobile/desktop visibility
    This prevents CLS from the search bar "popping in" after hydration */
    visibleSearchBar: isHomepage,
    stickySearchbar:
      web_7019_visible_search_bar_mweb === VARIANT_IDENTIFIER && isHomepage,
  };
}
